import { createSelector } from 'redux-orm';
import orm from 'shared_redux/reducers/models/orm';

const stateRoot = (state) => state.profile;

export const getIsUploadingAvatar = (state) => stateRoot(state).isUploadingAvatar;

export const getIsCreating = (state) => stateRoot(state).isCreating;

export const getIsEditing = (state) => stateRoot(state).isEditing;

export const getIsLoadingEmail = (state) => stateRoot(state).isLoadingEmail;

export const getAthleteId = (state) => stateRoot(state).athleteId;

export const getOrganizationId = (state) => stateRoot(state).organizationId;

export const getGroupId = (state) => stateRoot(state).groupId;

export const getFirstName = (state) => stateRoot(state).firstName || '';

export const getMiddleName = (state) => stateRoot(state).middleName || '';

export const getLastName = (state) => stateRoot(state).lastName || '';

export const getEmail = (state) => stateRoot(state).email || '';

export const getInviteStatus = (state) => stateRoot(state).inviteStatus || 'none';
// New selectors for teams and groups

// Get all non-default teams with their default groups
export const getTeamsWithDefaultGroups = createSelector(
    orm,
    state => state.database,
    (session) => {
        const Teams = session.Teams;
        return Teams.all()
            .filter(team => !team.is_default)
            .toModelArray()
            .map(team => {
                // Use default_group_id from the team object (provided by server)
                return {
                    ...team.ref,
                    defaultGroupId: team.ref.default_group_id || null
                };
            });
    }
);

// Get the default team and its default group ID
export const getDefaultOrgGroupId = createSelector(
    orm,
    state => state.database,
    (session) => {
        const Teams = session.Teams;
        const defaultTeam = Teams.all().filter(team => team.is_default).first();
        return defaultTeam ?
            (defaultTeam.groups.filter(group => group.is_default).first()?.id || null) :
            null;
    }
);

// Determine the selected team based on the state or the group ID
export const getSelectedTeamId = createSelector(
    orm,
    state => state.database,
    state => stateRoot(state).selectedTeamId,
    getGroupId,
    (session, directTeamId, groupId) => {
        // If we have a direct team ID selection (from UPDATE_ATHLETE_TEAM), use that
        if (directTeamId !== undefined && directTeamId !== null) {
            return directTeamId;
        }
        
        // Otherwise fall back to determining it from the group ID
        if (!groupId) return null;

        const Groups = session.Groups;
        const group = Groups.withId(groupId);
        return group ? group.team_id : null;
    }
);

// Get all groups for the selected team (including default groups)
// If no team is selected, return all groups from all teams
// Note: Default groups are included because athletes can be assigned to them (team-only assignment)
export const getGroupsForSelectedTeam = createSelector(
    orm,
    state => state.database,
    getSelectedTeamId,
    (session, selectedTeamId) => {
        const Teams = session.Teams;

        if (!selectedTeamId) {
            // No team selected - return all groups (including default) from all teams
            const allGroups = [];
            Teams.all().toModelArray().forEach(team => {
                const groups = team.groups.toRefArray();
                allGroups.push(...groups);
            });
            return allGroups;
        }

        const team = Teams.withId(selectedTeamId);
        return team ?
            team.groups.toRefArray() :
            [];
    }
);

export const getAthleteJSON = (state) => {
    let json = {
        first_name: getFirstName(state),
        middle_name: getMiddleName(state),
        last_name: getLastName(state),
        group_id: getGroupId(state),
    };
    
    // Include email if available
    const email = getEmail(state);
    if (email) {
        json.email = email;
    }

    // Include the team_id in the data sent to the server
    // This ensures the UI properly updates when clearing team/group
    const selectedTeamId = stateRoot(state).selectedTeamId;
    console.log("getAthleteJSON - selectedTeamId from Redux:", selectedTeamId);
    console.log("getAthleteJSON - group_id from Redux:", getGroupId(state));
    
    if (selectedTeamId !== undefined) {
        json.team_id = selectedTeamId;
    }

    // add id - optional as it's about create vs edit
    const id = getAthleteId(state);
    if (id) {
        json.id = id;
    }

    // add org id - optional as it's about create vs edit
    const organization_id = getOrganizationId(state);
    if (organization_id) {
        json.organization_id = organization_id;
    }

    console.log("getAthleteJSON - Final JSON payload:", json);
    return json;
};
